import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PromptContainer = styled.div `
  padding: ${themeGet('spacing.lg')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.75')};
`;
